import { useState } from 'react';
import { Button } from './ui/button';

function ClearCacheButton() {
  const [clearing, setClearing] = useState(false);

  const handleClearCache = async () => {
    if (!window.confirm('This will clear all cached data and reload the app. Continue?')) {
      return;
    }

    setClearing(true);

    try {
      // Unregister all service workers
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map(reg => reg.unregister()));
        console.log('Service workers unregistered');
      }

      // Clear all caches
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
        console.log('Caches cleared');
      }

      // Clear localStorage
      localStorage.clear();
      console.log('LocalStorage cleared');

      // Clear sessionStorage
      sessionStorage.clear();
      console.log('SessionStorage cleared');

      // Reload
      window.location.reload(true);
    } catch (error) {
      console.error('Error clearing cache:', error);
      alert('Failed to clear cache. Please try manually refreshing the page.');
      setClearing(false);
    }
  };

  // Only show in development or if holding shift key
  if (process.env.NODE_ENV === 'production' || window.location.hostname !== 'localhost') {
    return null;
  }

  return (
    <Button
      onClick={handleClearCache}
      disabled={clearing}
      variant="outline"
      size="sm"
      className="fixed bottom-4 right-4 z-50 bg-yellow-100 border-yellow-300 hover:bg-yellow-200"
    >
      {clearing ? 'Clearing...' : '🔧 Clear Cache'}
    </Button>
  );
}

export default ClearCacheButton;
